import axios from "axios";
import {
  SURVEY_OF_OWNER_FAIL,
  SURVEY_OF_OWNER_REQUEST,
  SURVEY_OF_OWNER_SUCCESS,
  SURVEY_OF_OWNER_CLEAR_ERRORS,
  SURVEY_REQUEST,
  SURVEY_SUCCESS,
  SURVEY_FAIL,
  SURVEY_CLEAR_ERRORS,
  SURVEY_OF_OWNER_ASSIGN_TO_USER_CLEAR_ERRORS,
  SURVEY_OF_OWNER_ASSIGN_TO_USER_FAIL,
  SURVEY_OF_OWNER_ASSIGN_TO_USER_REQUEST,
  SURVEY_OF_OWNER_ASSIGN_TO_USER_SUCCESS,
  SURVEY_ASSIGN_BY_SURVEY_ID_REQUEST,
  SURVEY_ASSIGN_BY_SURVEY_ID_SUCCESS,
  SURVEY_ASSIGN_BY_SURVEY_ID_FAIL,
  SURVEY_ASSIGN_BY_SURVEY_ID_CLEAR_ERRORS,
  SURVEY_ANS_SUBMIT_REQUEST,
  SURVEY_ANS_SUBMIT_SUCCESS,
  SURVEY_ANS_SUBMIT_FAIL,
  SURVEY_ANS_SUBMIT_CLEAR_ERRORS,
} from "../Constants/owner_surveys_constants";

export const get_owner_surveys = (owner_id) => async (dispatch) => {
  try {
    dispatch({
      type: SURVEY_OF_OWNER_REQUEST,
    });
    const surveys = await axios.get(
      `${process.env.REACT_APP_API_URL}/survey/survey_get/?`,
      {
        params: { owner: owner_id == null ? "" : owner_id },
      }
    );

    dispatch({
      type: SURVEY_OF_OWNER_SUCCESS,
      payload: surveys,
    });
  } catch (error) {
    dispatch({
      type: SURVEY_OF_OWNER_FAIL,
      payload: error.response,
    });
  }
};

export const add_owner_survey =
  (survey_payload, position, survey_assign_payload) => async (dispatch) => {
    try {
      dispatch({
        type: SURVEY_REQUEST,
      });
      const survey = await axios
        .post(`${process.env.REACT_APP_API_URL}/survey/survey-creation/`, {
          survey: survey_payload,
          position: position,
          survey_assign: survey_assign_payload,
        })
        .then((surv) => {
          axios.post(`${process.env.REACT_APP_API_URL}/survey/send-email/`, {
            survey_id: surv.data.Result?.survey
          });
        })
        .catch((err) => {
          console.log(err);
        });
      dispatch({
        type: SURVEY_SUCCESS,
        payload: survey,
      });
      return survey.data.id;
    } catch (error) {
      dispatch({
        type: SURVEY_FAIL,
        payload: error.response,
      });
    }
  };

export const update_owner_survey =
  (survey_payload, survey_assign_payload, owner_id) => async (dispatch) => {
    try {
      dispatch({
        type: SURVEY_OF_OWNER_REQUEST,
      });
      await axios
        .patch(`${process.env.REACT_APP_API_URL}/survey/survey-creation/`, {
          survey: survey_payload,
          survey_assign: survey_assign_payload,
        })
        .then((surv) => {
          console.log(surv);
          axios.post(`${process.env.REACT_APP_API_URL}/survey/send-email/`, {
            survey_update_id: surv.data.result

          });
        })
        .catch((err) => {
          console.log(err);
        });
      const surveys = await axios.get(
        `${process.env.REACT_APP_API_URL}/survey/survey_get/?`,
        {
          params: { owner: owner_id == null ? "" : owner_id },
        }
      );
      dispatch({
        type: SURVEY_OF_OWNER_SUCCESS,
        payload: surveys,
      });
      return surveys.data.id;
    } catch (error) {
      dispatch({
        type: SURVEY_OF_OWNER_FAIL,
        payload: error.response,
      });
    }
  };

export const delete_owner_survey = (id, owner_id) => async (dispatch) => {
  try {
    dispatch({
      type: SURVEY_OF_OWNER_REQUEST,
    });
    await axios.delete(`${process.env.REACT_APP_API_URL}/survey/survey/${id}/`);
    const surveys = await axios.get(
      `${process.env.REACT_APP_API_URL}/survey/survey_get/?`,
      {
        params: { owner: owner_id == null ? "" : owner_id },
      }
    );

    dispatch({
      type: SURVEY_OF_OWNER_SUCCESS,
      payload: surveys,
    });
  } catch (error) {
    dispatch({
      type: SURVEY_OF_OWNER_FAIL,
      payload: error.response,
    });
  }
};

export const owner_survey_clearErrors = () => async (dispatch) => {
  dispatch({
    type: SURVEY_OF_OWNER_CLEAR_ERRORS,
  });
};

export const owner_survey_actions_clearErrors = () => async (dispatch) => {
  dispatch({
    type: SURVEY_CLEAR_ERRORS,
  });
};

// user list

export const get_owner_surveys_user_list = (survey_id) => async (dispatch) => {
  try {
    dispatch({
      type: SURVEY_OF_OWNER_ASSIGN_TO_USER_REQUEST,
    });
    const surveys = await axios.get(
      `${process.env.REACT_APP_API_URL}/survey/get_surveyassign_by_owner/`,
      {
        params: { survey_id: survey_id }
      }
    );

    dispatch({
      type: SURVEY_OF_OWNER_ASSIGN_TO_USER_SUCCESS,
      payload: surveys.data.result,
    });
  } catch (error) {
    dispatch({
      type: SURVEY_OF_OWNER_ASSIGN_TO_USER_FAIL,
      payload: error.response,
    });
  }
};

export const get_owner_surveys_user_list_clearErrors =
  () => async (dispatch) => {
    dispatch({
      type: SURVEY_OF_OWNER_ASSIGN_TO_USER_CLEAR_ERRORS,
    });
  };

// survey assign by suvey id

export const get_owner_surveyassign_by_surveyid =
  (survey_id) => async (dispatch) => {
    try {
      dispatch({
        type: SURVEY_ASSIGN_BY_SURVEY_ID_REQUEST,
      });
      const surveys_assign = await axios.get(
        `${process.env.REACT_APP_API_URL}/survey/get_surveyassign/`,
        {
          params: { survey: survey_id == null ? "" : survey_id },
        }
      );

      dispatch({
        type: SURVEY_ASSIGN_BY_SURVEY_ID_SUCCESS,
        payload: surveys_assign.data.result,
      });
    } catch (error) {
      dispatch({
        type: SURVEY_ASSIGN_BY_SURVEY_ID_FAIL,
        payload: error.response,
      });
    }
  };

export const get_owner_surveyassign_by_surveyid_clear_errors =
  () => async (dispatch) => {
    dispatch({
      type: SURVEY_ASSIGN_BY_SURVEY_ID_CLEAR_ERRORS,
    });
  };
// submited ans

export const get_owner_surveys_ans_submited =
  (survey_id) => async (dispatch) => {
    try {
      dispatch({
        type: SURVEY_ANS_SUBMIT_REQUEST,
      });
      const isSubmit = await axios.get(
        `${process.env.REACT_APP_API_URL}/survey/any-survey-ans-submitted/`,
        {
          params: { survey_id: survey_id == null ? "" : survey_id },
        }
      );

      dispatch({
        type: SURVEY_ANS_SUBMIT_SUCCESS,
        payload: isSubmit,
      });
      return isSubmit;
    } catch (error) {
      dispatch({
        type: SURVEY_ANS_SUBMIT_FAIL,
        payload: error.response,
      });
    }
  };
export const get_owner_surveys_ans_submited_clear_errors =
  () => async (dispatch) => {
    dispatch({
      type: SURVEY_ANS_SUBMIT_CLEAR_ERRORS,
    });
  };
